export const convertDateTime = (dateTime) => {
  const date = new Date(dateTime + "Z");
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  const usTimeZone = date.toLocaleString("en-US", {
    ...options,
  });
  return `on ${usTimeZone}`;
};

export const getFilteredResults = (data, textQuery) => {
  const results = {};
  let lengthResults = 0;

  Object.keys(data).forEach((key) => {
    const filtered = data[key].filter((item) => {
      return !textQuery || item.title.toLowerCase().includes(textQuery.toLowerCase());
    });
    lengthResults += filtered.length;
    results[key] = filtered;
  });

  const uniqueResults = {};
  Object.keys(results).forEach((key) => {
    uniqueResults[key] = results[key].filter((item, index, self) => self.findIndex((t) => t.id === item.id) === index);
  });

  return { uniqueResults, hasResults: lengthResults > 0 };
};
